import {connect} from "react-redux";
import ActivityListing from "./list";
import {bindActionCreators} from "redux";
import {getCreatedActivities} from "../../../../service/Lead/action";
import {ratingSave} from "../../../../service/Dealer/action";
const mapStateToProps = (state) => ({
    activityList:state.Lead.activityList,
    savedRating: state.Dealer.savedRating,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getCreatedActivities,
            ratingSave
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ActivityListing);
